@import 'tailwindcss';

/*
  The default border color has changed to `currentcolor` in Tailwind CSS v4,
  so we've added these compatibility styles to make sure everything still
  looks the same as it did with Tailwind CSS v3.

  If we ever want to remove these styles, we need to add an explicit border
  color utility to any element that depends on these defaults.
*/
@layer base {
  *,
  ::after,
  ::before,
  ::backdrop,
  ::file-selector-button {
    border-color: var(--color-gray-200, currentcolor);
  }

  /* v4 placeholder defaults to 50% currentcolor; keep the v3 gray-400. */
  input::placeholder,
  textarea::placeholder {
    color: var(--color-gray-400);
  }
}